<template>
  <v-dialog
    :value="value"
    max-width="320px"
    persistent>
    <v-card flat>
      <v-toolbar flat color="accent" class="white--text">
        <v-toolbar-title>
         Multi Item Search
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-col cols="3">
        </v-col>
        <v-card-actions class="px-0">
          <v-btn
            icon
            dark
            text
            @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-toolbar>
     <v-container fluid class="ma-0 pa-0">
        <div class="modal-column">
          <v-form ref="form" lazy-validation>
              <v-container class="mt-0 pt-0">
              <v-row class="mt-0 pt-0">
                  <v-col style="padding-bottom: 8px">
                  <v-textarea
                      v-model="searchInput"
                      hint="Enter UPCs/item IDs on separate lines"
                      persistent-hint
                      :rules="[v => !!v || 'At least one UPC or item ID is required']"
                      rows="6"
                      outlined
                      dense>
                  </v-textarea>
                  </v-col>
              </v-row>
              <v-row dense class="mt-0 mb-1 pt-0 align-center">
                  <v-checkbox
                  class="ml-1 mr-2 mt-0"
                  label="UPC"
                  color="primary"
                  v-model="upc_search"
                  @change="$refs.item_id_search.validate()"
                  ref="upc_search"
                  dense
                  :rules="[atLeastOneTrue]"
                  :ripple="false">
                  </v-checkbox>
                  <v-checkbox
                  class="ml-4 mr-0 mt-0"
                  label="Item ID"
                  color="primary"
                  v-model="item_id_search"
                  @change="$refs.upc_search.validate()"
                  ref="item_id_search"
                  dense
                  :rules="[atLeastOneTrue]"
                  :ripple="false">
                  </v-checkbox>
              </v-row>
              <v-btn @click="submitSearch">
                  Search
              </v-btn>
              <v-btn color="grey darken-1" v-if="searchInput" text @click="clear">
                  Clear
              </v-btn>
              </v-container>
          </v-form>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { displayAlert } from '@/mixins/alert'
import { utils } from '@/mixins/utils'
import { userAccess } from '@/mixins/user-access'
export default {
  data () {
    return {
      searchInput: '',
      upc_search: false,
      item_id_search: true
    }
  },
  name: 'MultiSearchModal',
  components: {},
  mixins: [displayAlert, utils, userAccess],
  props: {
    value: Boolean,
    source: String
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
    atLeastOneTrue () {
      if (this.upc_search || this.item_id_search) return true
      return false
    },
    submitSearch () {
      const valid = this.$refs.form.validate()
      if (!valid) {
        return this.emitAlert(true, 'warning', 'Please check your form for errors')
      }
      const normalized = this.searchInput.split(/\r?\n/).flatMap(v => v ? v.trim() : [])
      const validValues = this.validateInputValues(normalized)
      if (!validValues) {
        return this.emitAlert(true, 'warning', 'Please make sure your search values contain only valid UPC/item ID characters and are at least 4 characters in length')
      }
      const payload = {
        sources: [this.source],
        values: normalized,
        item_id_search: this.item_id_search,
        upc_search: this.upc_search
      }
      this.$emit('search', payload)
    },
    validateInputValues (values) {
      if (this.tenant === 'pricechopper') {
        return values.every(val => {
          const validChars = /^[A-Za-z]*[0-9]+$/.test(val)
          return (validChars && val.length >= 4)
        })
      }
      return values.every(val => {
        const validChars = /^[D0-9]*$/.test(val)
        return (validChars && val.length >= 4)
      })
    },
    clear () {
      this.resetAlert()
      this.$refs.form.resetValidation()
      this.searchInput = ''
    },
  }
}
</script>
<style>
.modal-content-container {
  display: grid;
  grid-template-columns: minmax(auto, 290px) 1fr;
  grid-auto-flow: column;
  position: relative;
}
.modal-column {
  display: grid;
  width: 100%;
  padding: 0 12px 12px 12px;
}
</style>